
import Vue from 'vue'
import head from 'lodash/head'

import type { Breadcrumb, BreadcrumbRoute } from '../types/breadcrumb'
import type { UISharedFolderModel } from '../store/modules/folders/folders.model'
import type { TechpackRowItem } from '@/store/modules/techpacks/techpacks.model'
import { GetterTypes as FolderGetters, getters as folderGetters } from '@/store/modules/folders/folders.getters'
import {
  GetterTypes as TechpacksGetters,
  getters as techpackGetters
} from '@/store/modules/techpacks/techpacks.getters'
import { setBreadcrumb } from '@/utils/breadcrumbs'

export default Vue.extend({
  name: 'Breadcrumbs',
  methods: {
    navigateToBreadcrumb(breadcrumb: Breadcrumb): void {
      this.$router.push(`${breadcrumb.to}`)
    }
  },
  computed: {
    folders(): Array<UISharedFolderModel> {
      return folderGetters[FolderGetters.GET_COMPANY_FOLDERS](this.$store.state.folders)(this.$route.params.companyId)
    },
    techpacks(): Array<TechpackRowItem> {
      return techpackGetters[TechpacksGetters.GET_FOLDER_TECHPACKS](this.$store.state.techpacks)(
        this.$route.params.folderId
      )
    },
    company(): BreadcrumbRoute {
      const folder = head(this.folders)
      return {
        id: this.$route.params.companyId || '',
        name: folder?.company?.name || ''
      }
    },
    folder(): BreadcrumbRoute {
      const folder = this.folders.find(folder => folder._id === this.$route.params.folderId)
      return {
        id: this.$route.params.folderId || '',
        name: folder?.name || ''
      }
    },
    techpack(): BreadcrumbRoute {
      const techpack = this?.techpacks?.find(techpack => techpack?._id === this.$route.params.techpackId)
      return {
        id: this.$route.params.techpackId || '',
        name: techpack?.name || ''
      }
    },
    breadcrumbs(): Array<Breadcrumb> {
      if (!this.$route.meta?.breadcrumbs) {
        return []
      }
      return this.$route.meta.breadcrumbs.map((breadcrumb: Breadcrumb) => {
        const { text } = breadcrumb
        switch (text) {
          case ':companyName':
            return setBreadcrumb({ paramName: text, paramId: /:companyId/gi, ...this.company, ...breadcrumb })
          case ':folderName':
            return {
              ...setBreadcrumb({ paramName: text, paramId: /:folderId/gi, ...this.folder, ...breadcrumb }),
              // This piece of jank fills in the :companyId param
              to: setBreadcrumb({ paramName: text, paramId: /:folderId/gi, ...this.folder, ...breadcrumb }).to.replace(
                ':companyId',
                this.company.id || ''
              )
            }
          case ':techpackName':
            return setBreadcrumb({ paramName: text, paramId: /:techpackId/gi, ...this.techpack, ...breadcrumb })
          default:
            return {
              text: '',
              to: ''
            }
        }
      })
    }
  }
})
